/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Link} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "jspdf-autotable";
import TableHeader from "../../../Components/Common/TableHeader";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import AssignCard from "../../../Components/Students/AssignCard";
import AppContainer from "../../../Components/Structure/AppContainer";
import Pagination from "../../../Components/Common/Pagination";
import ajaxCard from "../../../util/remote/ajaxCard";
import Loader from "../../../Components/Common/Loader";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";

function AllPendingAttachments() {
  const [modal, setModal] = useStateCallback(false);
  const {schoolList} = useContext(SchoolContext); 
  const [school, setSchool] = useState("");

  const [studentList, setStudentList] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState("");
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState("");

  const getStudentList = async () => {
    setStudentList([]);
    setLoading(true);
    const server_response = await ajaxCard.fetchAllActivatedStudentsWithoutCardList(page);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setStudentList(server_response.details.data || []);
    } else {
      setStudentList([]);
    }
  };

  const searchStudentList = async (e) => {
    if (e) {
           e.preventDefault();
    }
    setLoading(true);
    const server_response = await ajaxCard.fetchAllSchoolActivatedStudentsWithoutCardList(page, school);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setStudentList(server_response.details.data || []);
    } else {
      setStudentList([]);
    }
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setSchool("");
    setPage(1);
    getStudentList();
    
    
  };

  const assignCard = async (e, item) => {
    setModal(false, () =>
      setModal(
        <AssignCard
          studentID={item.student_id}
          fullName={item.user}
          g={getStudentList}
          isOpen={true}
        />
      )
    );
  };

  useEffect(() => {
    if (school) {
      searchStudentList();
    } else {
      getStudentList();
    }
  }, [page]);

  return (
    <AppContainer title="Pending Attachments">
      <Toaster position="top-center" reverseOrder={false} />
        {modal}
      <div className="row">
        <div className="col-lg-12">
          <div className="card custom-card">
            <div className="card-body map-card">
              <div class="heading-layout1 mg-b-25">
                <TableHeader
                  title="Pending Cards / Wristbands Attachments"
                  subtitle="List of all the activated students without assigned cards/wristbands"
                />
                <div class="dropdown">
                  <Link
                    class="dropdown-toggle"
                    role="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    ...
                  </Link>

                  <div class="dropdown-menu dropdown-menu-right">
                    <Link class="dropdown-item" onClick={getStudentList}>
                      <i class="fas fa-redo-alt text-orange-peel"></i>Refresh
                    </Link>
                  </div>
                </div>
              </div>
              <form className="mg-t-20" onSubmit={searchStudentList}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
          
            <div className="col-lg-12 mt-2">
            <Select
                onChange={(e) => setSchool(e.school_id)}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                        school === "" ? null
                          : Array.isArray(schoolList) &&
                            schoolList.find((value) => value.school_id === school)
                      }
                
            />
            </div>
            
            
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
      </form>
              <div className="border-top mt-3"></div>
              <div className="table-responsive">
                {loading ? (
                  <Loader />
                ) : (
                  <table className="table display data-table text-nowrap">
                    <thead>
                      <tr>
                      <th scope="col" className="wd-10p">
                        No.
                      </th>
                      <th scope="col">Student Name</th>
                      <th scope="col">School</th>
                      <th scope="col">Activation Date</th>
                      <th scope="col">Activated By</th>

                      <th scope="col">Student to Receive</th>
                      <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                      {studentList.length > 0 ? (
                        studentList.map((item, index) => (
                          <tr key={index}>
                            <th scope='row' style={{width:"5px"}}>{index + first + 1}</th>
                                <td><Link to={`/school-students/profile/${item.student_id}/${item.user_id}`}>
                                {item.user}
                              </Link></td>
                                <td>{item.school}</td>
                                <td>{item.activation_date?.short_date}</td>
                                <td>{item.activated_by}</td>
                                <td>
                                  {item.card_status === "LOST" ? (
                                    <span className="badge badge-danger">LOST CARD</span>
                                  ) : item.activation_type === "4" ? (
                                    <span className="badge badge-info">CARD</span>
                                  ) : item.activation_type === "12" ? (
                                    <span className="badge badge-wb">WRISTBAND</span>
                                  ) : (
                                    <span className="badge badge-warning">IN REVIEW</span>
                                  )}
                                </td>
                                
                                                                <td>
                                                                {(item.card_status !== "LOST" &&
                                                                  (item.activation_type === "4" || item.activation_type === "12")) && (
                                                                    <Link
                                                                      className="btn btn-primary"
                                                                      onClick={(e) => assignCard(e, item)}
                                                                    >
                                                                      <i className="fa-solid fa-plus" /> Attach{" "}
                                                                      {item.activation_type === "4" ? "Card" : "Wristband"}
                                                                    </Link>
                                                                )}
                                                                </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center" }}>
                            No pending attachments.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
               
             
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}

export default AllPendingAttachments;
